type VisitId = number;
type VisitTag = `visit-${VisitId}`;
type DocumentTemplateTag = `documentTemplate-${VisitId}`;
type ConsentTemplateTag = `consentTemplate-${VisitId}`;
export const getVisitDraftTag = (visitId: VisitId): VisitTag => `visit-${visitId}`;
export const getDocumentTemplateDraftTag = (visitId: VisitId): DocumentTemplateTag => `documentTemplate-${visitId}`;
export const getConsentTemplateDraftTag = (visitId: VisitId): ConsentTemplateTag => `consentTemplate-${visitId}`;

const TEMPLATE_ID_REGEX = /-(?<number>\d+|-?\d+)$/u;
export const getTemplateDraftId = (draftToken: string): number | null => {
   const match = TEMPLATE_ID_REGEX.exec(draftToken);
   return match ? Number(match.groups?.number) : null;
};
